export const CASE_STATUS = {
  CONTROL_DESK: 2,
  TRACING: 3,
  MEDIC_INFORMATION: 4,
  MEDICAL_OPINION: 5,
  COST_CONTROL: 6,
  STORE_PATIENT: 7,
  FINISHED: 8,
  RECONSIDERATION: 9,
  CANCELED: 10,
  CASES_REPOSITORY: 11,
  EXTEMPORANEOUS_DICTUM: 12,
  OUT_HOSPITAL_FOLLOW_UP: 13,
  HOSPITAL_SUPERVISION: 14,
  CONCIERGE: 15,
};

export const EVENT_STAGES = {
  [CASE_STATUS.CONTROL_DESK]: "Mesa de Control",
  [CASE_STATUS.TRACING]: "Seguimiento", 
  [CASE_STATUS.MEDIC_INFORMATION]: "Informacion Medica",
  [CASE_STATUS.MEDICAL_OPINION]: "Dictamen Medico",
  [CASE_STATUS.COST_CONTROL]: "Control de Costos",
  [CASE_STATUS.STORE_PATIENT]: "Almacenar Paciente",
  [CASE_STATUS.FINISHED]: "Casos Finalizados Hospital",
  [CASE_STATUS.RECONSIDERATION]: "Reconsideracion",
  [CASE_STATUS.CANCELED]: "Cancelado",
  [CASE_STATUS.CASES_REPOSITORY]: "Repositorio de Casos",
  [CASE_STATUS.EXTEMPORANEOUS_DICTUM]: "Dictamen Extemporáneo",
  [CASE_STATUS.OUT_HOSPITAL_FOLLOW_UP]: "Seguimiento Extrahospitalario",
  [CASE_STATUS.HOSPITAL_SUPERVISION]: "Supervision Hospitalaria",
  [CASE_STATUS.CONCIERGE]: "Concierge",
}; 